import {
  createClient as baseCreateClient,
  type ClientConfig,
  type Route,
} from "@prismicio/client";
import { enableAutoPreviews } from "@prismicio/next";
import sm from "../slicemachine.config.json";

/**
 * The project's Prismic repository name.
 */
export const repositoryName =
  process.env.NEXT_PUBLIC_PRISMIC_ENVIRONMENT || sm.repositoryName;

/**
 * A list of Route Resolver objects that define how a document's `url` field is resolved.
 *
 * {@link https://prismic.io/docs/route-resolver#route-resolver}
 */
// TODO: Update the routes array to match your project's route structure.
const routes: Route[] = [
  // Examples:
  { type: "home_page", path: "/" },
  { type: "section", path: "/:uid" },
  { type: "article", path: "/articles/:uid" }
];

/**
 * Creates a Prismic client for the project's repository. The client is used to
 * query content from the Prismic API.
 *
 * @param config - Configuration for the Prismic client.
 */
export const linkResolver = (doc: { type?: string; uid?: string }) => {
  switch (doc.type) {
    case "home_page":
      return "/";
    case "section":
      return doc.uid ? `/${doc.uid}` : "/";
    case "article":
      return doc.uid ? `/articles/${doc.uid}` : "/articles";
    case "faq":
      return "/faqs";
    default:
      return "/";
  }
};

export const createClient = (config: ClientConfig = {}) => {
	const isProd = process.env.NODE_ENV === "production";

	const client = baseCreateClient(repositoryName, {
		routes,
		fetchOptions: isProd
			? {
				next: {
					revalidate: 86400,
				},
			}
			: {
				cache: "no-store",
			},
		...config,
	});

	enableAutoPreviews({ client });

	return client;
};

